import { SkypeNotificationOptions, OwsOptionsFeatureType } from 'owa-outlook-service-options';
import { createStore } from 'satcheljs';

export default createStore<SkypeNotificationOptions>('swcOptions', {
    skypeMessageNotification: null,
    skypeCallingNotification: null,
    feature: OwsOptionsFeatureType.SkypeNotifications,
});
